import {Injectable, EventEmitter} from '@angular/core';
import {ApiClientService} from './api-client.service';
import {KeyLog} from '../types/data.types';
import {UrlService} from './url.service';
import {EmptyRowService} from './empty-row.service';
import {ConstantsService} from './constants.service';
import {AccountPermissionsService} from './account-permissions.service';
import {HistoryItem} from '../views/directory-item/activity/history-item.class';

declare const toastr: any;
declare const swal: any;
declare const $: any;

@Injectable()
export class UserStatisticsService {
    isKeyLogModalShow = false;
    returnKeyModal = false;
    signOutKeyModal = false;
    showHistoryModal = false;
    isViewModalShow = false;
    showServiceUnavailable = false;

    keyLoginKeyLogModal: KeyLog;

    data = {
        allKeyLogs: {
            get: '/v1/key_log.json?expand=building,suite,resident,incidentReportType,createdBy,activities',
            data: [],
            total: null
        },
    };
    tabId = 'keyLog';
    spinnerShow = true;
    detailedViewHistorySpinnerShow = false;
    buildings:    Array<any> = [];
    buildingsForRead: Array<any> = [];
    buildingsForUpdate: Array<any> = [];
    serviceName: string = 'key_log';
    selectedItemData: any;
    showDetailedView = false;
    activities = [];
    corporationSettings = null;
    settingsLoaded: EventEmitter<any> = new EventEmitter();

    constructor(
        public api: ApiClientService,
        public urlService: UrlService,
        public emptyRowService: EmptyRowService,
        public account: AccountPermissionsService
    ) {
        this.api.onLogout.subscribe(() => this.buildings = []);
    }

    getData(scrollToTop?) {
        this.showServiceUnavailable = false;
        this.spinnerShow = true;
        this.data[this.tabId].total = null;

        const tabId       = this.urlService.queryParams['tab'];
        const url         = this.data[tabId].get;
        const queryParams = this.urlService.getQueryParamsString();

        this.api.get('domainKeyLog', `${url}${queryParams}`).subscribe(
            (res) => {
                const body = JSON.parse(res._body);
                const entities = body.entities;
                this.data[tabId].data = [];
                this.data[tabId].total = body.total;
                this.emptyRowService.fillEmptyRow();
                entities.map(item => {
                    if (item.building && item.building.bdId) return item.building.id = item.building.bdId;
                });
                this.account.addEntitiesPermissions(entities, this.serviceName);
                this.keyLogFactory(entities, this.data[tabId].data);
                if (this.selectedItemData) {
                    this.selectedItemData = this.data[tabId].data.find(si => si.id == this.selectedItemData.id);
                    if(this.selectedItemData) {
                        this.selectedItemData.checked = true;
                        this.getActivity();
                    } else
                        this.showDetailedView = false;
                }
                this.spinnerShow = false;
                if($('.table')[0] && scrollToTop)
                    $('.table')[0].scrollIntoView();
            },
            (error) => {
                this.spinnerShow = false;
                this.showServiceUnavailable = true;
                this.api.errorHandler(error, 'Failed get Key Log');
            }
        );
    }

    keyLogFactory(entities: any, targetArray) {
        entities.forEach((kLog) => {
            const keyLog = new KeyLog();

            if (kLog.keyTag              ) keyLog.keyTag               = kLog.keyTag;
            if (kLog.building            ) keyLog.buildingId           = +kLog.building.bdId;
            if (kLog.building            ) keyLog.buildingName         = kLog.building.name;
            if (kLog.id                  ) keyLog.id                   = +kLog.id;
            if (kLog.otherResident       ) keyLog.otherResident        = kLog.otherResident;
            if (kLog.otherSuite          ) keyLog.otherSuite           = kLog.otherSuite;
            if (kLog.resident            ) keyLog.residentId           = +kLog.resident.bdId;
            if (kLog.resident            ) keyLog.residentFullName     = kLog.resident.fullName;
            if (kLog.suite               ) keyLog.suiteId              = +kLog.suite.bdId;
            if (kLog.suite               ) keyLog.suiteNumber          = kLog.suite.suiteNumber;
            if (kLog.notes               ) keyLog.notes                = kLog.notes;
            if (kLog.purpose             ) keyLog.purpose              = kLog.purpose;
            if (kLog.status              ) keyLog.status               = kLog.status;
            keyLog.isCanEdit = kLog.isCanEdit;
            keyLog.isCanDelete = kLog.isCanDelete;

            targetArray.push(keyLog);
        });
    }

    getBuildings(): void {
        if (this.buildings.length) return;
        const url = `/v1/buildings/short.json?per-page=10000&order-by=name|asc&expand=timeZone`;
        this.api.get('domainBD', url).subscribe(
            (res)   => {
                this.buildings = JSON.parse(res._body).entities;
                this.getFilteredBuildings();
                },
            (error) => this.api.errorHandler(error, 'Failed get buildings')
        );
    }

    resetData() {
        for (const item in this.data) {
            this.data[item].data = [];
            this.data[item].total = null;
        }
    }

    signOutKey(keyLog: KeyLog) {
        this.signOutKeyModal   = true;
        this.keyLoginKeyLogModal = Object.assign({}, keyLog);
    }

    returnKey(keyLog: KeyLog) {
        this.returnKeyModal   = true;
        this.keyLoginKeyLogModal = Object.assign({}, keyLog);
    }

    deleteKeyLog(keyLog: KeyLog): void {
        if (!keyLog.id) return;
        swal(ConstantsService.getSwalConfig('Delete Key Log'),
            () => {
                const url = `/v1/key_log/${keyLog.id}.json`;
                this.api.remove('domainKeyLog', url).subscribe(
                    () => {
                        toastr.success('Key Log has been deleted.');
                        this.toggleDetailedView(null);
                        this.getData();
                    },
                    (error) => this.api.errorHandler(error, 'Delete Key Log failed')
                );
            }
        );
    }

    editKeyLog(keyLog) {
        this.keyLoginKeyLogModal = JSON.parse(JSON.stringify(keyLog));
        this.isKeyLogModalShow = true;
    }

    viewKeyLog(keyLog) {
        this.keyLoginKeyLogModal = Object.assign({}, keyLog);
        this.isViewModalShow = true;
    }

    getHistory(keyLog: KeyLog): void {
        this.showHistoryModal = true;
        this.keyLoginKeyLogModal = Object.assign({}, keyLog);
    }

    canEdit(buildingId?: number) {

        return this.account.canUpdate(this.serviceName, buildingId);
    }

    canDelete(buildingId?: number) {

        return this.account.canDelete(this.serviceName, buildingId);
    }

    getFilteredBuildings() {
        this.buildingsForRead =  this.account.getBuildingsForRead(this.buildings, this.serviceName);
        this.buildingsForUpdate = this.account.getBuildingsForUpdate(this.buildings, this.serviceName);
    }

    toggleDetailedView(data): void {
        this.activities = [];
        if(data && (!this.selectedItemData || this.selectedItemData.id != data.id)) {
            if(this.selectedItemData)
                this.selectedItemData.checked = false;
            this.selectedItemData = null;
            this.showDetailedView = true;
            data.checked = true;
            setTimeout(() => {
                this.selectedItemData = data;
                this.getActivity();
                for (const field in this.selectedItemData.formFields)
                    this.selectedItemData.formFields[field].editMode = false;
            });
        } else if(this.selectedItemData && data && this.selectedItemData.id == data.id) {
            this.selectedItemData = null;
            this.showDetailedView = false;
            data.checked = false;
        } else {
            this.showDetailedView = false;
            this.selectedItemData.checked = false;
            this.selectedItemData = null;
        }
    }

    getActivity() {
        if (this.selectedItemData) {
            this.detailedViewHistorySpinnerShow = true;
            const url = `/v1/activity.json?per-page=10000&order-by=createdAt|desc&expand=user,createdBy&key_log_id=${this.selectedItemData.id}`;
            this.api.get('domainKeyLog', url).subscribe(
                (res)   => this.activities = JSON.parse(res._body).entities,
                (error) => this.api.errorHandler(error, 'Failed to get History'),
                () => this.detailedViewHistorySpinnerShow = false
            );
        }
    }

    getSettingsForCorporation(corporationNumberId) {
        const url = `/v1/service_settings/${corporationNumberId}.json?expand=staffNotificationSettings`;
        this.api.get('domainKeyLog', url).subscribe(
            res => {
                this.corporationSettings = null;
                const body = JSON.parse(res._body);
                this.corporationSettings = body ? body : null;
                this.settingsLoaded.emit();
            }, error => {
                if(error.statusText == 'Not Found') {
                    this.corporationSettings = null;
                    this.settingsLoaded.emit();
                } else
                    this.api.errorHandler(error, 'Failed to get key log settings for the chosen corporation');
            }
        );
    }
}



// WEBPACK FOOTER //
// /app/src/app/services/user-statistics.service.ts